export default __webpack_public_path__ + "static/media/myClimbsIcon.eb2f7e0e.png";